import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./FinishToggle.scss";

// Fallback defaults — used only if no config is supplied via JSON/props
const DEFAULT_HEADING = "Choose your finish";
const DEFAULT_OPTIONS = [
    { key: "Metal", label: "Metal Design", sequence: "DCover_Metal" },
    { key: "Plastic", label: "Plastic Groove", sequence: "DCover_Plastic" },
];

const FinishToggle = ({ inline = false, config }) => {
    const toggleHeading = config?.heading || DEFAULT_HEADING;
    const OPTIONS = config?.options && config.options.length ? config.options : DEFAULT_OPTIONS;

    const [selected, setSelected] = useState(() => {
        return window.DCoverType === "plastic" ? "Plastic" : "Metal";
    });

    const [isVisible, setIsVisible] = useState(true);

    const applySequence = (optionKey) => {
        const option = OPTIONS.find((o) => o.key === optionKey);

        if (
            option &&
            window.scene &&
            typeof window.scene.applySequence === "function"
        ) {
            window.scene.applySequence(window[option.sequence]);
        }
    };

    const handleSelect = (optionKey) => {
        if (optionKey === selected) return;

        setSelected(optionKey);

        window.DCoverType = optionKey === "Plastic" ? "plastic" : "metal";

        window.dispatchEvent(
            new CustomEvent("DCoverTypeChange", { detail: window.DCoverType })
        );

        applySequence(optionKey);
    };

    useEffect(() => {
        const syncFromGlobal = (e) => {
            const val = e?.detail ?? window.DCoverType;
            setSelected(val === "plastic" ? "Plastic" : "Metal");
        };

        window.addEventListener("DCoverTypeChange", syncFromGlobal);
        return () => window.removeEventListener("DCoverTypeChange", syncFromGlobal);
    }, []);

    useEffect(() => {
        if (inline) return;

        window.handleFinishToggle = (value = false) => {
            if (value) {
                setSelected(window.DCoverType === "plastic" ? "Plastic" : "Metal");
            }
            setIsVisible(value);
        };

        return () => {
            delete window.handleFinishToggle;
        };
    }, [inline]);

    if (!inline && !isVisible) return null;

    const content = (
        <div className="finishToggle" onClick={(e) => e.stopPropagation()}>
            <span className="finishToggleLabel">{toggleHeading}</span>

            <div
                className="finishToggleGroup"
                role="radiogroup"
                aria-label="Finish"
            >
                {OPTIONS.map(({ key, label }) => (
                    <div
                        key={key}
                        className={`finishToggleOption ${key} ${
                            selected === key ? "active" : ""
                        }`}
                        onClick={() => handleSelect(key)}
                        role="radio"
                        tabIndex={0}
                        aria-checked={selected === key}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleSelect(key);
                            }
                        }}
                    >
                        {label}
                    </div>
                ))}
            </div>
        </div>
    );

    if (inline) {
        return content;
    }

    const portalRoot = document.getElementById("finishToggle");
    return portalRoot ? ReactDOM.createPortal(content, portalRoot) : null;
};

export default FinishToggle;